<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-0 col-xl-4" />
      <div class="col-md-6 col-12 col-xl-4">
        <h5 class="mb-4 mt-4">Welcome to {{ fgTitle }}!</h5>
        <h6 class="text-danger" v-if="errorMessage != ''">
          {{ errorMessage }}
        </h6>
        <form @submit.prevent="signIn">
          <div class="form-group">
            <label for="email">Email address</label>
            <input
              type="email"
              class="form-control"
              id="curUsername"
              aria-describedby="emailHelp"
              placeholder="Enter email"
              autocomplete="username"
              v-model="signInEmail"
            />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input
              type="password"
              class="form-control"
              id="curPassword"
              placeholder="Password"
              autocomplete="current-password"
              v-model="signInPassword"
            />
          </div>
          <button
            type="button"
            v-on:click="forgotPassword"
            class="btn btn-link"
            style="float:left;"
          >
            Forgot My Password
          </button>
          <button type="submit" class="btn btn-primary" style="float:right;">
            Sign In
          </button>
        </form>
      </div>
      <div class="col-md-3 col-0 col-xl-4" />
    </div>
    <ForgotPasswordModal />
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { nittyGritty } from "@/constants/NittyGritty.js";
import ForgotPasswordModal from "@/modals/ForgotPasswordModal.vue";
import $ from "jquery";

export default {
  name: "SignIn",
  components: {
    ForgotPasswordModal
  },
  mounted() {
    if (this.$route.query.passwordchanged) {
      this.$showSnackbar("Your password has been changed.", true);
    }
  },
  data() {
    return {
      signedIn: false,
      signInEmail: "",
      signInPassword: "",
      errorMessage: "",
      fgTitle: nittyGritty.fundsGrantedTitle
    };
  },
  methods: {
    async signIn() {
      this.$store.commit("updateLoading", true);
      var view = this;
      view.$data.errorMessage = "";
      Auth.signIn({
        username: view.$data.signInEmail.toLowerCase(), // Required, the username
        password: view.$data.signInPassword // Optional, the password
      })
        .then(async data => {
          await view.$loadUser(data.username);
          view.$router.push("myhome");
          this.$store.commit("updateLoading", false);
        })
        .catch(err => {
          switch (err.code) {
            case "UserNotFoundException":
              view.$data.errorMessage =
                "The email address entered was not found. Make sure the email address is correct, or contact us to create an account.";
              break;
            case "NotAuthorizedException":
              view.$data.errorMessage =
                "Incorrect email address or password. If you forgot your password select forgot my password below, or contact us to create an account.";
          }
          console.log(err);
          this.$store.commit("updateLoading", false);
        });
    },
    forgotPassword() {
      $("#forgotPasswordModal").modal("show");
    }
  }
};
</script>
